import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fdatetime } from "@/lib/format";
import { EmptyState, Loader, StatusBadge } from "@/components/common";

const ST = { en_attente: ["En attente", "warning"], approuve: ["Approuvé", "success"], refuse: ["Refusé", "danger"] };

export function MyRequests() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/me/requests").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  if (!items) return <Loader />;
  if (!items.length) return <EmptyState title="Aucune demande" text="Les opérations, groupes et événements que vous soumettez au bureau apparaîtront ici." testId="my-requests-empty" />;
  return (
    <div className="space-y-2" data-testid="my-requests">
      {items.map((r) => (
        <div key={r.id} className="mr-card p-4" data-testid="my-request-row">
          <div className="flex justify-between gap-3"><p className="font-medium">{r.kind_label} · {r.title}</p><StatusBadge status={r.status} label={ST[r.status]?.[0]} tone={ST[r.status]?.[1]} /></div>
          <p className="text-xs text-mr-muted mt-1">{fdatetime(r.created_at)}</p>
          {r.status === "refuse" && r.reason && <p className="text-sm text-mr-danger mt-1">Motif : {r.reason}</p>}
        </div>
      ))}
    </div>
  );
}
